<template>
  <main
    id="stock"
    class="page-container stock-index"
    v-if="$route.name === 'listini'"
  >
    <section class="cards-grid-stock">
      <router-link
        v-for="cat in categories"
        :key="cat.slug"
        :to="`/home/listini/${cat.slug}`"
        class="card-stock"
        :aria-label="cat.label"
      >
        <span class="icon-wrap">
          <i :class="cat.icon" aria-hidden="true"></i>
        </span>
        <span class="label">{{ cat.label }}</span>
      </router-link>
    </section>
  </main>
  <router-view />
</template>

<script>
/**
 * Indice dei listini.
 *
 * Il progetto prevede UNA SOLA scheda, generica e senza dati. L'elenco è
 * centralizzato in `@/config/listiniCategories`, dove è documentato anche il
 * criterio con cui è stata scelta.
 *
 * In modalità demo l'intera sezione è comunque irraggiungibile: la voce di
 * menu è nascosta via CSS e le rotte sono bloccate dal router.
 */
import { listiniCategories } from "@/config/listiniCategories";

export default {
  name: "ListiniPage",
  data() {
    return {
      categories: listiniCategories(),
    };
  },
};
</script>

<style src="@/css/StockPage.css" />
